<template>
    <v-navigation-drawer app clipped fixed
                         mobile-breakpoint="lg"
                         width="300px"
                         :value="isOpen"
                         color="grey lighten-4">
        <component :is="currentSidebar"/>
    </v-navigation-drawer>
</template>

<script>
  import QuestionList from "./QuestionList";
  import MarkingList from "./MarkingList";
  import ScoringTaskList from "./ScoringTaskList";
  import ScoringAnswerList from "./ScoringAnswerList";
  import ReportsFilters from "./ReportsFilters";

  export default {
    name: "theSidebar",

    components: {QuestionList, MarkingList, ScoringTaskList, ScoringAnswerList, ReportsFilters},

    computed: {
      TASK() {
        return this.$store.getters.GET_TASK;
      },
      currentSidebar() {

        if (this.$route.path.indexOf('/create') > -1) {
          return 'question-list'
        }

        if (this.$route.path.indexOf('/find') > -1) {
          return 'marking-list'
        }

        if (this.$route.path.indexOf('/mark') > -1 && this.TASK !== 'mark') {
          return 'scoring-task-list'
        }

        if (this.$route.path.indexOf('/reports') > -1 && this.TASK !== 'mark') {
          return 'reports-filters'
        }

        if (this.$route.path.indexOf('/mark') > -1 && this.TASK === 'mark') {
          return 'scoring-answer-list'
        }

        return 'question-list'
      },
      isOpen: {
        get() {
          return this.$store.getters.SIDEBAR
        },
        set() {
          this.$store.commit('TOGGLE_SIDEBAR')
        }
      }
    }
  }
</script>

<style scoped>

</style>
